window.addEventListener('load', () => {
    if (window.location.pathname.match(/^\/collections\/.*$/)) {
        Shopify.analytics.publish("view_item_list", {item_list_name: document.title});
    }
});

function addItemCardListeners() {
    const productCards = document.querySelectorAll('[class*="#product-card"]');
    
    productCards.forEach(productCard => {
        productCard.addEventListener('click', () => {
            const titleElement = productCard.querySelector('h3');
            if (!titleElement) {
                return;
            }

            Shopify.analytics.publish("select_item", 
                                      {
                                        item_list_name: document.title, 
                                        items: [{ item_name: titleElement.textContent.trim() }]
                                      });
        });
    });
}

document.addEventListener('DOMContentLoaded', addItemCardListeners);